import { trackDashboardCtaClicked } from "analytics";
import { PATHS } from "constants/pathConstants";
import { FORM_IDS } from "constants/v3/formConstants";
import NextMoveCard from ".";
import Translate from "translate/Translate";
import { useSelector } from "react-redux";
import { selectSubmissionByFormId } from "store/reducers/formTemplates/FormTemplatesSlice";
import { wasCologuardQualificationSurveyCompletedWithCologuardSuggestion } from "utils/v3/nextMoveUtils";
import { useNextMoveMemberContext } from "./useNextMoveMemberContext";

const CologuardCheckIn01NextMoveCard = () => {
  const {
    flattenedSurveyAnswers,
    hasCompletedCologuardQualificationSurvey,
    memberNeedsToTalkToNav
  } = useNextMoveMemberContext();
  const cologuardAcknowledgementSubmission = useSelector(
    selectSubmissionByFormId(FORM_IDS.COLOGUARD_ACKNOWLEDGEMENT)
  );

  if (
    !hasCompletedCologuardQualificationSurvey ||
    memberNeedsToTalkToNav ||
    cologuardAcknowledgementSubmission ||
    !wasCologuardQualificationSurveyCompletedWithCologuardSuggestion(
      flattenedSurveyAnswers
    )
  ) {
    return null;
  }

  return (
    <NextMoveCard
      id="cologuard-check-in-01-next-move"
      title={
        <Translate text="Looks like it's time for colon cancer screening" />
      }
      body={
        <Translate text="Based on the answers you provided, it may be time for colon cancer screening. Talk to our navigation team about options or, if you prefer a non-invasive option, learn more about Cologuard." />
      }
      link={{
        onClick: () => {
          trackDashboardCtaClicked({
            workflow: "colon_cancer_screening",
            ctaLocation: "next_move_card",
            ctaId: "colon_cancer_screening"
          });
        },
        text: "Learn more about Cologuard or schedule time to talk with our navigation team",
        url: PATHS.COLOGUARD_LAUNCH_PAGE
      }}
    />
  );
};

export default CologuardCheckIn01NextMoveCard;
